import AxiosAPI from '../../../utils/AxiosAPI';

// operation for load logged in users
export const handleLoadLoggedUserList = () =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth-manage`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// operation for log out single user
export const handleLogoutOpe = (id) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth-manage/${id}/force-logout`)
            .put()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// operation for log out all users
export const handleLogoutAllOpe = () =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth-manage/force-logout-all-users`)
            .put()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
